export default {"src":"/_next/static/media/az.a387da6a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};